var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineVideoTime(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 22.75c-5.43 0-7.75-2.32-7.75-7.75V9c0-5.43 2.32-7.75 7.75-7.75h6c5.43 0 7.75 2.32 7.75 7.75v6c0 .24 0 .49-.02.72-.03.3-.24.56-.53.65a.744.744 0 0 1-.8-.25 3.716 3.716 0 0 0-2.9-1.37c-.85 0-1.68.29-2.34.82-.9.71-1.41 1.77-1.41 2.93 0 1.13.5 2.19 1.37 2.9.24.19.33.51.25.8-.09.29-.34.5-.65.53-.23.02-.48.02-.72.02H9zM2.75 9v6c0 4.61 1.64 6.25 6.25 6.25h5.02c-.5-.81-.77-1.76-.77-2.75 0-1.62.72-3.11 1.98-4.1 1.68-1.36 4.23-1.48 6.02-.38V9c0-4.61-1.64-6.25-6.25-6.25H9C4.39 2.75 2.75 4.39 2.75 9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.52 7.86c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h18.96a.749.749 0 1 1 0 1.5H2.52z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.77 6.97V2.11c0-.41.34-.75.75-.75s.75.34.75.75v4.86c0 .41-.34.75-.75.75s-.75-.34-.75-.75zM14.73 6.52V2.11c0-.41.34-.75.75-.75s.75.34.75.75v4.41c0 .42-.33.75-.75.75-.41 0-.75-.34-.75-.75z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.17 22.56a5.2 5.2 0 0 1-1.92-4.06c0-1.62.72-3.11 1.98-4.1.92-.74 2.08-1.15 3.27-1.15 1.59 0 3.07.7 4.06 1.93.76.92 1.19 2.1 1.19 3.32 0 1.49-.65 2.93-1.78 3.94-.98.85-2.21 1.31-3.47 1.31-1.22 0-2.4-.42-3.33-1.19zm.99-6.99c-.9.71-1.41 1.77-1.41 2.93 0 1.13.5 2.19 1.37 2.9 1.36 1.13 3.47 1.12 4.86-.09a3.81 3.81 0 0 0 1.27-2.81c0-.87-.3-1.71-.85-2.37a3.709 3.709 0 0 0-2.9-1.38c-.85 0-1.68.29-2.34.82z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.739 20.02c-.21-.36-.1-.82.26-1.03l1.04-.62v-1.26c0-.41.34-.75.75-.75s.75.34.75.75v1.69c0 .26-.14.51-.36.64l-1.41.84a.94.94 0 0 1-.39.1c-.25 0-.5-.13-.64-.36z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineVideoTime);
export default __webpack_public_path__ + "static/media/vuesax-outline-video-time.22d2210e686ed54a4a542942fc219563.svg";
export { ForwardRef as ReactComponent };